import { Modal, message } from 'antd';
import React, { FC } from 'react';
import { getProductId } from '@/infrastructure/product-info';
import { TapdParams } from '@/presentation/components/tapd';
import { releaseTapdIssue } from '@/presentation/components/tapd/api';
import { Zone } from '@/proto/field';
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  releaseParams: TapdParams;
  onHide: () => void;
  onSubmit: () => void;
}

/**
 * 取消关联tapd组件
 */

export const ReleaseTapdModal: FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { visible, releaseParams, onHide, onSubmit } = props;
  const deleteTapd = async () => {
    const succ = await releaseTapdIssue({
      productId: getProductId(),
      type: Zone.Exception,
      issueKey: releaseParams.issueKey,
    });
    if (succ?.baseRsp?.code === 0) {
      message.success(t("取消关联成功"));
    } else {
      message.error(t("取消关联失败"));
      return;
    }
    onSubmit();
    onHide();
  };
  return (<Modal
      centered
      title={t("取消关联确认")}
      visible={visible}
      onOk={() => deleteTapd()}
      onCancel={() => onHide()}
    >
      {t("你确认要取消此问题与缺陷的关联吗？")}
    </Modal>
  );
};
